
import { supabase } from "@/integrations/supabase/client";

export interface WordPressCredentials {
  siteUrl: string;
  username: string;
  password: string;
}

/**
 * Gets WordPress credentials for a website from Supabase
 */
export const getCredentials = async (websiteId: string): Promise<WordPressCredentials | null> => {
  try {
    console.log('Getting credentials for website:', websiteId);
    
    const { data, error } = await supabase
      .from('wordpress_credentials')
      .select('site_url, username, password')
      .eq('website_id', websiteId)
      .maybeSingle();

    if (error) {
      console.error('Error getting credentials from database:', error);
      return null;
    }

    if (!data) {
      console.log('No credentials found for website:', websiteId);
      return null;
    }

    return {
      siteUrl: data.site_url,
      username: data.username,
      password: data.password,
    };
  } catch (error) {
    console.error('Error getting credentials:', error);
    return null;
  }
};

/**
 * Saves WordPress credentials for a website to Supabase
 */
export const saveCredentials = async (
  websiteId: string, 
  credentials: WordPressCredentials
): Promise<boolean> => {
  try {
    console.log('Saving credentials for website:', websiteId);
    
    const { error } = await supabase
      .from('wordpress_credentials')
      .upsert({
        website_id: websiteId,
        site_url: credentials.siteUrl,
        username: credentials.username,
        password: credentials.password,
        updated_at: new Date().toISOString(),
      }, {
        onConflict: 'website_id'
      });

    if (error) {
      console.error('Error saving credentials to database:', error);
      return false;
    }

    console.log('Credentials saved successfully for website:', websiteId);
    return true;
  } catch (error) {
    console.error('Error saving credentials:', error);
    return false;
  }
};

/**
 * Deletes WordPress credentials for a website from Supabase
 */
export const deleteCredentials = async (websiteId: string): Promise<boolean> => {
  try {
    console.log('Deleting credentials for website:', websiteId);
    
    const { error } = await supabase
      .from('wordpress_credentials')
      .delete()
      .eq('website_id', websiteId);

    if (error) {
      console.error('Error deleting credentials from database:', error);
      return false;
    }

    console.log('Credentials deleted successfully for website:', websiteId);
    return true;
  } catch (error) {
    console.error('Error deleting credentials:', error);
    return false;
  }
};
